export function DocumentLinkRow({
  label,
  onPress,
}: {
  label: string;
  onPress?: () => void;
}) {
  const content = (
    <>
      <span className="flex items-center gap-[17px]">
        <FileTextIcon />
        <span className="text-20 font-bold">{label}</span>
      </span>
      <ChevronRightIcon />
    </>
  );

  return (
    <div className="px-[6px]">
      {onPress === undefined ? (
        <div className="flex h-[30px] items-center justify-between">
          {content}
        </div>
      ) : (
        <button
          type="button"
          onClick={onPress}
          className="flex h-[30px] w-full items-center justify-between"
        >
          {content}
        </button>
      )}
      <hr className="mt-4 border-t border-divider-soft" />
    </div>
  );
}

function FileTextIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0" aria-hidden="true">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
        <path d="M14 3v5h5" />
        <path d="M9 13h6M9 17h6" />
      </g>
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0" aria-hidden="true">
      <path
        d="m9 5 7 7-7 7"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
